import { Dropdown, DropdownProps } from 'antd';
import classNames from 'classnames';
import { memo } from 'react';

import { icons } from 'utils/constants/icons';

const { MoreOutlined } = icons;

export const OptionsMenu = memo((props: DropdownProps) => {
  const classes = classNames(
    'border px-[20px] py-[8px] rounded-[6px] mt-[4px]',
    props.disabled
      ? 'border-[#d9d9d9] bg-[#c2c2c2] cursor-not-allowed text-[white]'
      : 'border-[#00538F]',
    props.className,
  );

  return (
    <Dropdown trigger={['click']} className={classes} {...props}>
      <MoreOutlined className="text-[22px] text-[#00538F]" />
    </Dropdown>
  );
});
